import { createElementBlock as t, openBlock as r, createElementVNode as o } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
};
function l(c, e) {
  return r(), t("svg", n, [...e[0] || (e[0] = [
    o("circle", {
      cx: "11",
      cy: "11",
      r: "10.5",
      fill: "#27AE60"
    }, null, -1),
    o("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m6.5 11 3.79 3.5 5.21-7"
    }, null, -1)
  ])]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
